export const IsURL = url => {
  var pattern = new RegExp(
    '^((http|https):\\/\\/)?(([a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]+)|((25[0-5]|2[0-4][0-9]|[1][0-9][0-9]|[1-9][0-9]|[0-9]?)(\\.(25[0-5]|2[0-4][0-9]|[1][0-9][0-9]|[1-9][0-9]|[0-9]?)){3}(:?[0-9]*)))(\\/.*)?$',
    'i'
  );
  return pattern.test(url);
};

export const PathHelper = {
  ensureEndSlash: function(path) {
    return this.hasEndSlash(path) ? path : this.addEndSlash(path);
  },
  ensureStartSlash: function(path) {
    return this.hasStartSlash(path) ? path : this.addStartSlash(path);
  },
  ensureNoEndSlash: function(path) {
    return this.hasEndSlash(path) ? this.removeLastChar(path) : path;
  },
  ensureNoStartSlash: function(path) {
    return this.hasStartSlash(path) ? this.removeFirstChar(path) : path;
  },
  hasEndSlash: function(path) {
    return path[path.length - 1] === '/';
  },
  addEndSlash: function(path) {
    return path + '/';
  },
  removeLastChar: function(path) {
    return path.slice(0, -1);
  },
  hasStartSlash: function(path) {
    return path[0] === '/';
  },
  addStartSlash: function(path) {
    return '/' + path;
  },
  removeFirstChar: function(path) {
    return path.substring(1, path.length);
  }
};

export const getUrlVars = (search) => {
  return search.replace('?', '').split('&').reduce((acc, keyVal) => {
    const [ key, value ] = keyVal.split('=');
    if (key) {
      acc[key] = value;
    }
    return acc;
  }, {});
}

/** gets the currentRuleSetName from the window url */
export const getCurrentRuleSetName = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return new URLSearchParams(window.location.search).get('current_rule_set_name') || undefined;
}

/** returns the current business line using the currentRuleSetName
 *  if no valid ruleSets are provided, returns FALSE (for case where ruleSets haven't been fetched yet)
 *  returns undefined if there isn't a currentRuleSet
 */
export const getCurrentBusinessLine = (ruleSets, currentRuleSetName) => {
  if (!currentRuleSetName) {
    currentRuleSetName = getCurrentRuleSetName();
  }
  if (!currentRuleSetName) {
    return undefined;
  }
  if (!ruleSets) {
    return false;
  }
  const currentRuleSet = ruleSets.find(ruleSet => ruleSet.name === currentRuleSetName);
  return currentRuleSet && (currentRuleSet.business_lines || []).join(',');
}

export const loadScript = src => (
  new Promise((resolve, reject) => {
    try {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => { resolve() };
      script.onerror = () => {
        const failingFile = src.split('/').slice(-2).join('/');
        reject(`An issue occured while trying to load the following file: ${failingFile}`);
      };
      document.body.appendChild(script);
    } catch (e) {
      reject(e);
    }
  })
);
